import React from 'react';

import { Relevant } from '../ExtendedRelevantField';

export const withRelevantField = (props) => {
  const {
    field,
    relevantCondition,
    checkAdditionalRelevantCondition,
    additionalRelevantCondition
  } = props;
  return (
    <Relevant
      key={field}
      when={({ values }) => {
        if (checkAdditionalRelevantCondition) {
          return eval(relevantCondition) && additionalRelevantCondition;
        }
        return eval(relevantCondition);
      }}
    >
      {props.component}
    </Relevant>
  );
};

export const getWrappedWithRelevantField = (fieldProps) => {
  const {
    field,
    isRelevant,
    relevantCondition,
    component,
    checkAdditionalRelevantCondition,
    additionalRelevantCondition
  } = fieldProps;
  return isRelevant
    ? withRelevantField({
        field,
        relevantCondition,
        component,
        checkAdditionalRelevantCondition,
        additionalRelevantCondition
      })
    : component;
};

export const getRelevantLabel = (fieldProps) => {
  //NOTE: values are used to evaluate the condition
  const { relevantLabel, values } = fieldProps;
  return eval(relevantLabel);
};
